import { useEffect, useRef, useState } from 'react';

export default function VideoBackground() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoError, setVideoError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleError = (e: Event) => {
      console.error('Video error:', e);
      setVideoError(true);
    };

    video.addEventListener('error', handleError);

    return () => {
      video.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <div className="absolute inset-0 -top-20 w-full h-[calc(80vh+5rem)]">
      <div className="absolute inset-0 z-20 bg-gradient-to-b from-[#E6F7F4]/80 via-[#E6F7F4]/50 to-[#C5E8E3]/70" />
      {!videoError && (
        <div className="absolute inset-0 z-10">
          <video
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          >
            <source 
              src="/biocap.mp4"
              type="video/mp4" 
            />
          </video>
        </div>
      )}
    </div>
  );
} 